
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

export const RestaurantsBySlider = () => {
  const $sliderWrapper = $('.js-restaurantsBySlider__sliderWrapper');
  if ( !$sliderWrapper.length ) {
      return
  }

  $(document).ready(function() {
    new Swiper('.js-restaurantsBySlider__sliderWrapper', {
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 20,
      pagination: {
        clickable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },

        992: {
          slidesPerView: 5,
          centeredSlides: false,
        },
      },
  
      // Navigation arrows
      navigation: {
        nextEl: '.js-restaurantsBySlider__nextSlide',
        prevEl: '.js-restaurantsBySlider__prevSlide',
      },
    })
  })
}